function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("rect", {
  x: 21.049,
  y: 18.36,
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -8.1458 22.0536)",
  width: 3,
  height: 5.001
}), React.createElement("polygon", {
  points: "1.689,0 2.043,3.89 8.445,10.293 11.981,6.757 5.578,0.354  "
}), React.createElement("polygon", {
  points: "22.549,14.496 21.135,15.91 16.932,11.707 13.396,15.242 17.599,19.446 16.185,20.86 16.892,21.567 23.256,15.203     "
}), React.createElement("rect", {
  x: 0.328,
  y: 19.36,
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -13.9217 8.1097)",
  width: 5.001,
  height: 3
}), React.createElement("polygon", {
  points: "23.334,3.89 23.688,0 19.799,0.354 4.242,15.91 2.828,14.496 2.121,15.203 8.485,21.567 9.192,20.86 7.778,19.446     "
}));

var SvgVs = function SvgVs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    fill: "#000000",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25.377 23.688",
    style: {
      enableBackground: "new 0 0 25.377 23.688"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vs.6f20ee44.svg";
export { ForwardRef as ReactComponent };